/**
 * PCM Direct Mail Planning Guide - Multi-step Form
 *
 * Drives the `#form-dm-planning-guide` step-by-step wizard: shows one
 * `<fieldset>` at a time, wires up its Next/Previous buttons, and updates
 * a step counter. This is a standalone UI widget with its own
 * step-fieldset markup, separate from the pcm-form-handler plugin's
 * multi-step convention.
 */
(function($) {
  'use strict';

  function initDirectMailPlanner() {
    $('#form-dm-planning-guide').each(function() {
      const $form = $(this);
      const $fieldsets = $form.children('fieldset');

      if (!$fieldsets.length || $form.data('pcmDmPlannerInitialized')) {
        return;
      }

      $form.data('pcmDmPlannerInitialized', true);

      let currentIndex = Math.max(0, $fieldsets.index($fieldsets.filter('#first').first()));
      const $stepCounter = $form.closest('.dm-planner-form').find('.dm-planner-form__steps-current');
      const questionCount = $fieldsets.length - 1; // The final fieldset is the completion state.

      const showStep = function(index, animate) {
        currentIndex = Math.max(0, Math.min(index, $fieldsets.length - 1));

        $fieldsets
          .stop(true, true)
          .hide()
          .removeClass('is-active')
          .attr('aria-hidden', 'true');

        const $currentStep = $fieldsets.eq(currentIndex);

        if (animate) {
          $currentStep.fadeIn(180);
        } else {
          $currentStep.show();
        }

        $currentStep
          .addClass('is-active')
          .attr('aria-hidden', 'false');

        if ($stepCounter.length) {
          $stepCounter.text(Math.min(currentIndex + 1, questionCount));
        }
      };

      $form.on('click.pcmDmPlanner', '.next', function(event) {
        event.preventDefault();
        showStep(currentIndex + 1, true);
      });

      $form.on('click.pcmDmPlanner', '.previous', function(event) {
        event.preventDefault();
        showStep(currentIndex - 1, true);
      });

      $form.on('click.pcmDmPlanner', '.submit', function() {
        $form.closest('.dm-planner-form').addClass('is-submitting');
      });

      showStep(currentIndex, false);
    });
  }

  if ($ && $.fn) {
    $(initDirectMailPlanner);
  }
})(window.jQuery);
